import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import AreasService from "services/Admin/AreasService"
import CitiesService from "services/Admin/CitiesService"
import CriteriaService from "services/Admin/CriteriaService"
import DeveloperService from "services/Admin/DeveloperService"
import SelectOptions from "components/SelectOptions"
//Import Images
import error from "assets/images/error-img.png";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import Select from "react-select";
import Language from "Enums/Language"
import RattingService from "services/Admin/RattingService"
const languages = ["en", "ar", "zh", "ru"]

function EditModal({ 
    modal, toggle, add, developers,getList, Service, editRate, setShowSuccessModal, deletedRatesList, setDeletedRatesList ,viewStatus }) {
    const service = new Service()
    const [developersData, setDevelopersData] = useState([])
    const [loading, setLoading] = useState(false)
    const [selectedDeveloper, setSelectedDeveloper] = useState(null)
    const [craterialOptions, setCrateriaOptions] = useState([])
    const [ratesData, setRatesData] = useState(add ? [{
        rate: "",
        rating_criteria: null
    }
    ] : [])

    useEffect(() => {
        setDevelopersData([...developers])
    }, [developers])



    useEffect(() => {
         if (!add) {
            setSelectedDeveloper({ label: editRate.name, value: editRate.developer_id })
            const craterias = editRate.craterias.map(rate => {
                return {
                    id: rate.id,
                    rate: rate.rate,
                    rating_criteria: {
                        label: rate.rating_criteria.name,
                        value: rate.rating_criteria.id
                    }
                }
            })

            setRatesData(craterias)
        }
    }, [editRate])
    const hasCrateria = () => {
        ratesData.forEach(rate => {
            if (!rate.rating_criteria) {
                return false
            }
        })
        return true
    }
    const handleValidSubmit = () => {
        if (!selectedDeveloper || !hasCrateria()) {
            toast.error("please select developer and criteria")
            return
        }
        setLoading(true)
        const craterias = ratesData.map(rate => {
            if (rate.rate !== "") {
                return {
                    criteria_id: rate.rating_criteria.value,
                    rate: rate.rate
                }
            } else {
                return {
                    criteria_id: rate.rating_criteria.value,
                }
            }
        })
        const data = {
            developer_id: selectedDeveloper.value,
            rates: craterias
        }
        if (editRate) {

            Promise.all(
                deletedRatesList.map(async (deletedItem) => {
                    await service.remove(deletedItem)
                }),
            ).then(() => {
                service.update(editRate.developer_id, data).then(response => {
                    if (response && response.status === SuccessOk) {
                        toast.success(response.data.success)
                        getList()
                        toggle()
                    }else {
                        setLoading(false)
                      }
                })
            })

        } else {
            service.create(data).then(response => {
                if (response && response.status === SuccessCreated) {
                    setLoading(false)
                    getList()
                    toggle()
                    setShowSuccessModal(true)
                }else {
                    setLoading(false)
                  }
            })
        }

    }
    const deleterHandelr = (rate, index) => {
        if (rate ?.id) {
            const updatedData = ratesData.filter((item, index2) => {
                return index !== index2
            })
            setDeletedRatesList((list) => [...list, rate.id])
            setRatesData([...updatedData])
        } else {
            const updatedData = ratesData.filter((item, index2) => {
                return index !== index2
            })
            setRatesData([...updatedData])
        }
    }
    const getTotalRate = (ratesData) => {
        let sum = 0
        ratesData.forEach(item => {
            if (!isNaN(item.rate)) {
                sum = sum + item.rate
            } else {
                sum = sum + 0
            }


        })

        return ratesData ?.length === 0 ? sum / 1 : sum / ratesData ?.length
    }

    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader toggle={toggle}>
            {viewStatus ? "View Rate" : add ? "Add New Rate":"Edit Rate"}   
            </ModalHeader>
            <ModalBody>
                <AvForm
                    className='form-horizontal'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit();
                    }}>
                    {add && <Row>
                        <Col md={12}>

                            <label>Developer</label>
                            <Select
                                name='Developer'
                                placeholder='Select'
                                options={developersData}
                                onChange={data => setSelectedDeveloper(data)}
                                className='mb-3'
                                bsSize='lg'
                                value={selectedDeveloper}
                            />

                        </Col>
                    </Row>}
                    {ratesData.map((rate, index) => {
                        return (
                            <Row key={index}>
                                {!viewStatus && index >= 1 && <Row >
                                    <Col md={12} className="d-flex flex-row-reverse">
                                        <button type="button"
                                            className="btn btn-danger m-0 py-1 px-2"
                                            onClick={() => deleterHandelr(rate, index)}  >X</button>
                                    </Col>
                                </Row>}
                                <Col md={6}>
                                    <SelectOptions
                                        label='Criteria'
                                        placeholder='Select'
                                        options={craterialOptions.filter(({ label: l1 }) => !ratesData.some(({ rating_criteria }) => l1 === rating_criteria ?.label))}
                                        handleSelectChange={(data) => {
                                            const updated = ratesData.map((item, itemIndex) => {
                                                if (index === itemIndex) {
                                                    return { ...item, rating_criteria: data }
                                                }
                                                return item
                                            })
                                            setRatesData([...updated])
                                        }}
                                        selectedOption={rate.rating_criteria}
                                        Service={CriteriaService}
                                        setOptions={(options) => {
                                            setCrateriaOptions(options)
                                        }}
                                    />
                                </Col>
                                <Col md={6} >
                                    <AvField
                                        className="mb-3"
                                        name={"rate"}
                                        label={"Rate"}
                                        bsSize="lg"
                                        value={rate.rate}
                                        onChange={e => {
                                            const value = parseInt(e.target.value)
                                            const updated = ratesData.map((item, itemIndex) => {
                                                if (index === itemIndex) {
                                                    return { ...item, rate: value }
                                                }
                                                return item
                                            })
                                            setRatesData([...updated])
                                        }}
                                        required={false}
                                        placeholder={"rate Default 50%"}
                                        type={"number"}
                                        min={"1"}
                                        max={"100"}

                                    />
                                </Col>
                            </Row>
                        )
                    })}
                    {!viewStatus ? ratesData ?.length < craterialOptions ?.length && <Row>
                        <Col>
                            <button 
                            type="button"
                             onClick={() => {
                                setRatesData([...ratesData, {
                                    rate: "",
                                    rating_criteria: null
                                }])
                            }} 
                            className="btn-hover"
                            style={{ background: "none", border: "none", color: "green", opacity: ".6" }}
                            disabled={loading ? true : false}
                            ><i className="fas fa-plus-circle"></i>Add New Rate</button>
                        </Col>
                    </Row>:null}
                    <Row className="mt-2">
                        <p className="fw-bold font-size-18">Total Rate : {getTotalRate(ratesData).toFixed(2)}%</p>
                    </Row>
                    {!viewStatus ? <ModalFooter className="px-0">
                    <button type='submit' className='btn btn-success w-100'>
                           {  add ? "Add Rate" : "Update Rate" }
                        </button>
                    </ModalFooter>:null} 
                </AvForm>
            </ModalBody>
        </Modal >
    );
}

export default EditModal;
